import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import resultsReducer from "./resultsSlice";
import progressReducer from "./progressSlice";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from "redux-persist";

const persistConfig = {
    key: 'brandstarter',
    storage,
}

const rootReducer = combineReducers({
    user: userReducer,
    results: resultsReducer,
    progress: progressReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})

export const persistor = persistStore(store)